
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/payment-initiation/payments-dashboard",
      function () {
        return require("private-next-pages/docs/payment-initiation/payments-dashboard.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/payment-initiation/payments-dashboard"])
      });
    }
  